module.exports = __webpack_public_path__ + "img/nbus_trans.76e383bd.png";